module.exports = __webpack_public_path__ + "img/next.4310cf9b.png";